import { ICellRendererParams } from "ag-grid-community";
import { FC } from "react";
import AlertIcon from "components/portfolio/components/alert";
import {
  ALERT_ICON_TYPE,
  TYPE_TO_VALUE_KEY_MAPPING,
} from "components/portfolio/components/alert/alert-icon-type";
import { classHOC } from "components/app/ClassWrapper";

const AlertRenderer: FC<ICellRendererParams> = ({ node, data, api, columnApi }) => {
  if (node.rowPinned) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
      {ALERT_ICON_TYPE.map((type) =>
        data?.alertsOverview?.[TYPE_TO_VALUE_KEY_MAPPING[type]] ? (
          <AlertIcon
            type={type}
            accountKey={data?.accountKey}
            gridEvent={{ api, columnApi, type: "portfolio" }}
            accountLevelMutateKeys={["/api/dataservice/v1/alerts/overview"]}
            key={`${type}`}
          />
        ) : (
          <span
            style={{ width: 24 }}
            key={`${type}`}
          >
            {" "}
          </span>
        )
      )}
    </div>
  );
};

export default classHOC(AlertRenderer);
